export default {"src":"/_next/static/media/IDEAL.ea706301.svg","height":1598,"width":1844,"blurWidth":0,"blurHeight":0};